"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainLinkFundValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
exports.chainLinkFundValidationSchema = (0, yup_1.object)().shape({
    subscriptionId: (0, yup_1.string)().required("form.validations.valueMissing"),
    amount: yup_rules_eth_1.bigNumberValidationSchema.min(1, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map